import Flickity from "flickity";
import "flickity/dist/flickity.min.css";
import { debouncer, slideUp, slideDown, slideToggle } from "../Utility/utils";
import { smoother } from "../Utility/gsap";
import { BuildModal, checkToCloseModal, prepToOpenModal } from "./modal";

const InitDocumentationLightbox = () => {
  const triggers = document.querySelectorAll(".documentation_lightbox__open, [data-doc-lightbox]");
  if (triggers.length) {
    triggers.forEach((trigger, i) => {
      const imgURL = trigger.getAttribute("data-target")
        ? trigger.getAttribute("data-target")
        : trigger.firstElementChild?.src;

      const img = document.createElement("img");
      img.setAttribute("src", imgURL);
      let modal = BuildModal("lightbox-modal-" + (i + 1), "lightbox-modal", img);

      trigger.addEventListener("click", (e) => {
        console.log("click event fired");
        // Open modal
        if (!trigger.closest(".documentation_slider.dragging")) {
          console.log("no closest slider");
          prepToOpenModal(e, modal);
        }

        trigger.clickEventWatching = true;
      });
    });
  }
};

const ToggleMobileDocumentationNav = () => {
  const menuToggle = document.querySelector(".documentation__menu__toggle");
  if (!!menuToggle && !menuToggle.clickEventWatching) {
    menuToggle.preventDefault = true;
    menuToggle.clickEventWatching = true;

    const menu = document.querySelector(".documentation__menu");

    menuToggle.addEventListener("click", (e) => {
      e.preventDefault();
      menuToggle.blur();
      menu.classList.toggle("active");
    });
  }
};

const NavClickEvents = () => {
  const navA = document.querySelectorAll(".documentation-nav a:not(.documentation__menu__toggle)");
  const menu = document.querySelector(".documentation__menu");
  if (navA) {
    navA.forEach((link) => {
      if (!link.clickEventWatching) {
        link.clickEventWatching = true;

        link.addEventListener("click", (e) => {
          link.blur();

          if (menu.classList.contains("active")) {
            menu.classList.remove("active");
          }
        });
      }
    });
  }
};

const documentationAccordions = () => {
  const accordionTriggers = document.querySelectorAll(".accordion__trigger a");

  if (accordionTriggers) {
    accordionTriggers.forEach((trigger) => {
      if (!trigger.clickEventWatching) {
        trigger.clickEventWatching = true;
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          trigger.blur();

          const parentWrap = trigger.closest(".accordion__wrap");
          const itemWrap = trigger.closest(".accordion__item");
          const target = itemWrap.querySelector(".accordion__content");

          if (trigger.classList.contains("active")) {
            trigger.classList.remove("active");
            target.classList.remove("active");
            slideUp(target);
          } else {
            const activeContent = parentWrap.querySelector(".accordion__content.active");
            const activeTrigger = parentWrap.querySelector(".accordion__trigger a.active");

            if (!!activeContent) {
              activeContent.classList.remove("active");
              activeTrigger.classList.remove("active");
              slideUp(activeContent);
            }

            trigger.classList.add("active");
            target.classList.add("active");
            slideDown(target);
          }
        });
      }
    });
  }
};

const InitDocumentationSliders = () => {
  const sliders = document.querySelectorAll(".documentation_slider");

  if (sliders) {
    sliders.forEach((slider) => {
      // First, set up an element for the slider nav
      const sliderWrapper = slider.closest(".documentation__gallery_wrap");
      const sliderNav = document.createElement("div");
      sliderNav.classList.add("documentation__gallery_nav");
      sliderWrapper.appendChild(sliderNav);

      // Loop through each image getting the thumbnail URL
      const images = slider.querySelectorAll("img");
      images.forEach((image, index) => {
        const thumbnail = image.getAttribute("data-thumb");
        const alt = image.getAttribute("alt");

        const navEl = document.createElement("button");
        navEl.classList.add("documentation__gallery_thumb");
        if (index === 0) {
          navEl.classList.add("is-selected");
        }

        const imageEl = document.createElement("img");
        imageEl.setAttribute("src", thumbnail);
        imageEl.setAttribute("alt", alt);

        navEl.appendChild(imageEl);
        sliderNav.appendChild(navEl);
      });

      // Create the slider
      const flkty = new Flickity(slider, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: "left",
        adaptiveHeight: true,
      });

      // Add class to slider when changing, for use with lightbox images
      flkty.on("dragStart", (event, pointer) => {
        slider.classList.add("dragging");
      });
      flkty.on("dragEnd", (event, pointer) => {
        setTimeout(() => {
          slider.classList.remove("dragging");
        }, 500);
      });

      // Hook up slider nav to change slider when clicked
      const navButtons = sliderNav.querySelectorAll("button");

      // update buttons on select
      flkty.on("select", function () {
        const previousSelectedButton = sliderNav.querySelector(".is-selected");
        const selectedButton = sliderNav.querySelectorAll("button")[flkty.selectedIndex];
        previousSelectedButton.classList.remove("is-selected");
        selectedButton.classList.add("is-selected");
      });

      // cell select
      navButtons.forEach((button, index) => {
        button.addEventListener("click", (e) => {
          flkty.select(index);
        });
      });
    });
  }
};

export const InitDocumentation = () => {
  NavClickEvents();
  documentationAccordions();
  ToggleMobileDocumentationNav();
  InitDocumentationSliders();
  InitDocumentationLightbox();
};
